import React from 'react'
import { useTranslation } from 'react-i18next'

import { common } from '../../../constants'

const Footer = () => {
  const [t] = useTranslation()

  return (
    <div className="footer">
      <div className="footer-links-wrapper">
        <a
          href={common.TERM_OF_USE}
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.term_of_use')}
        </a>
        <a
          href={common.PRIVACY_POLICY}
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.privacy_policy')}
        </a>
        <a
          href={common.CONTACT_US}
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.contact_us')}
        </a>
      </div>
      <div className="copyright-text">{t('footer.copyright')}</div>
    </div>
  )
}

export default Footer
